/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";

const EmployeeListService = () => {
  const [emplistdata, setEmplistdata] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("")
  const [totalEmployee, setTotalEmployee] = useState(0)
  const [employeeExportData, setEmployeeExportData] = useState([])
  const [organizationInfoEmpExport, setOrganizationInfoEmpExport] = useState({})
  const [employeeListExportLoading, setEmployeeListExportLoading] = useState(false)

  const location = useLocation();
  const currentRoute = location.pathname.split('/').pop();
  const { fetchData } = useAPIHandler();
  useEffect(() => {
    getEmployeeListFn();
  }, [rowsPerPage, currentPage, searchQuery]);

  const getEmployeeListFn = () => {
    const url = currentRoute === "employee-list" ? `/employee?pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`
      :
      currentRoute === "employee-onboarding" ? `/employee?pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&filter=onboarding`
        :
        currentRoute === "employee-permanent" ? `/employee?pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&filter=permanent`
          :
          currentRoute === "employee-probation" ? `/employee?pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&filter=probation`
            :
            currentRoute === "employee-exit" ? `/employee?pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&filter=resign`
              :
              currentRoute === "employee-inactive" ? `/employee?pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&filter=inactive`
                : `/employee?pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`
    fetchData({ url })
      .then((res) => {
        try {
          const fetchedData = res?.data?.data || [];
          setEmplistdata(fetchedData);
          setTotalEmployee(res?.data?.totalCount)
          setTotalPages(res?.data?.pagesNumber);
        } catch (error) {
          logger.log(error);
        }
      })
      .catch((err) => {
        logger.log(err);
      });
  };

  const getEmployeeExpotFn = () => {
    setEmployeeListExportLoading(true)
    const url = currentRoute === "employee-list" ? "/employee"
      :
      currentRoute === "employee-onboarding" ? "/employee?filter=onboarding"
        :
        currentRoute === "employee-permanent" ? `/employee?filter=permanent`
          :
          currentRoute === "employee-probation" ? `/employee?filter=probation`
            :
            currentRoute === "employee-exit" ? `/employee?filter=resign`
              :
              currentRoute === "employee-inactive" ? `/employee?filter=inactive`
                : '/employee'
    fetchData({ url })
      .then((res) => {
        try {
          const fetchedData = res?.data?.data || [];
          setEmployeeExportData(fetchedData);
        } catch (error) {
          logger.log(error);
        }
      })
      .catch((err) => {
        logger.log(err);
      })
      .finally(() => {
        setEmployeeListExportLoading(false)
      })
  };
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value.target.value));
    setCurrentPage(0);
  };

  // https://api.nouee.com/v1/report/salary?month=1&year=2025&pageLimit=25&page=1&search=

  const fetchAllSalaryReportData = async () => {
    try {
      const url = "report/salary?month=1&year=2025&pageLimit=25&page=1&search="
      const response = await fetchData({
        url: url,
        method: 'GET',
      });
      setOrganizationInfoEmpExport(response?.data?.org_details)
      logger.log(response, "salaryReportListData7777")
    } catch (error) {
      logger.log(error)
    }

  }
  useEffect(() => {
    getEmployeeExpotFn()
    fetchAllSalaryReportData()
  }, [])


  logger.log(employeeExportData, "employeeExportData999")

  return {
    emplistdata,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    getEmployeeListFn,
    totalEmployee,
    employeeExportData,
    organizationInfoEmpExport,
    employeeListExportLoading
  };
};

export default EmployeeListService;
